// src/features/tuition/services/financesService.js

export const fetchPayments = async (userId, dateRange) => {
    // In a real app, this would be an API call
    // return await api.get(`/api/users/${userId}/tuition/payments`, { params: dateRange });
    
    // For demo purposes, return mock data
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          {
            id: '1',
            studentId: '1',
            studentName: 'Emma Johnson',
            amount: 450,
            date: '2025-04-15',
            method: 'bank transfer',
            status: 'paid',
            description: 'Mathematics tuition - April 2025'
          },
          {
            id: '2',
            studentId: '2',
            studentName: 'Liam Smith',
            amount: 600,
            date: '2025-04-10',
            method: 'cash',
            status: 'paid',
            description: 'Mathematics and Life Sciences tuition - April 2025'
          },
          {
            id: '3',
            studentId: '3',
            studentName: 'Sophia Williams',
            amount: 300,
            date: '2025-03-28',
            method: 'bank transfer',
            status: 'paid',
            description: 'English tuition - March 2025'
          }
        ]);
      }, 300);
    });
  };
  
  export const fetchInvoices = async (userId, dateRange) => {
    // In a real app, this would be an API call
    // return await api.get(`/api/users/${userId}/tuition/invoices`, { params: dateRange });
    
    // For demo purposes, return mock data
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          {
            id: '1',
            studentId: '1',
            studentName: 'Emma Johnson',
            issueDate: '2025-04-01',
            dueDate: '2025-04-15',
            items: [
              { description: 'Mathematics tuition - 4 sessions', quantity: 4, rate: 150, amount: 600 }
            ],
            subtotal: 600,
            tax: 0,
            total: 600,
            status: 'paid',
            paidAmount: 600
          },
          {
            id: '2',
            studentId: '2',
            studentName: 'Liam Smith',
            issueDate: '2025-04-01',
            dueDate: '2025-04-15',
            items: [
              { description: 'Mathematics tuition - 3 sessions', quantity: 3, rate: 150, amount: 450 },
              { description: 'Life Sciences tuition - 2 sessions', quantity: 2, rate: 175, amount: 350 }
            ],
            subtotal: 800,
            tax: 0,
            total: 800,
            status: 'partial',
            paidAmount: 600
          },
          {
            id: '3',
            studentId: '3',
            studentName: 'Sophia Williams',
            issueDate: '2025-04-01',
            dueDate: '2025-04-15',
            items: [
              { description: 'English tuition - 4 sessions', quantity: 4, rate: 125, amount: 500 }
            ],
            subtotal: 500,
            tax: 0,
            total: 500,
            status: 'unpaid',
            paidAmount: 0
          }
        ]);
      }, 300);
    });
  };
  
  export const fetchFinancialStats = async (userId) => {
    // In a real app, this would be an API call
    // return await api.get(`/api/users/${userId}/tuition/finance/stats`);
    
    // For demo purposes, return mock data
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          totalEarnings: 1350,
          pendingPayments: 700,
          paidInvoices: 1,
          unpaidInvoices: 2
        });
      }, 300);
    });
  };

  export const fetchUpcomingSessions = async (userId) => {
    // In a real app, this would be an API call
    // return await api.get(`/api/users/${userId}/tuition/dashboard/upcoming-sessions`);
    
    // For demo purposes, return mock data
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          { id: 1, studentName: 'Emma Johnson', subject: 'Mathematics', date: '2025-04-19', time: '15:00', duration: 60 },
          { id: 2, studentName: 'Liam Smith', subject: 'Physics', date: '2025-04-20', time: '16:30', duration: 90 },
          { id: 3, studentName: 'Sophia Williams', subject: 'Chemistry', date: '2025-04-21', time: '14:00', duration: 60 }
        ]);
      }, 300);
    });
  };
  
  export const fetchRecentPayments = async (userId) => {
    // In a real app, this would be an API call
    // return await api.get(`/api/users/${userId}/tuition/dashboard/recent-payments`);
    
    // For demo purposes, return mock data
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          { id: 1, studentName: 'Emma Johnson', amount: 350, date: '2025-04-15', status: 'paid' },
          { id: 2, studentName: 'Liam Smith', amount: 450, date: '2025-04-14', status: 'paid' },
          { id: 3, studentName: 'Sophia Williams', amount: 200, date: '2025-04-10', status: 'overdue' }
        ]);
      }, 300);
    });
  };
  
  export const fetchStudentCount = async (userId) => {
    // In a real app, this would be an API call
    // return await api.get(`/api/users/${userId}/tuition/dashboard/student-count`);
    
    // For demo purposes, return mock data
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          total: 15,
          active: 12
        });
      }, 300);
    });
  };
  
  export const fetchFinancialSummary = async (userId) => {
    // In a real app, this would be an API call
    // return await api.get(`/api/users/${userId}/tuition/dashboard/financial-summary`);
    
    // For demo purposes, return mock data
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          total: 8500,
          pending: 1200
        });
      }, 300);
    });
  };
  
  export const fetchTodaySessions = async (userId) => {
    // In a real app, this would be an API call
    // return await api.get(`/api/users/${userId}/tuition/dashboard/today-sessions`);
    
    // For demo purposes, return mock data
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          { id: 4, studentName: 'Oliver Brown', subject: 'English', time: '17:00', duration: 60, completed: true },
          { id: 5, studentName: 'Noah Davis', subject: 'Biology', time: '18:30', duration: 60, completed: false }
        ]);
      }, 300);
    });
  };